export default import.meta.ROLLUP_FILE_URL_XivDCLKvo3rsiwL$eU0pkA;